import { BasicContentService } from '@common/services/basic-content-service';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { Util } from '@common/utils/util';
import { AppService } from '@src/suite/app.service';
import { EnpsField } from '@src/suite/common/data-models/fields/enps-field';
import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';

// TODO REMOVE THIS
export class EnpsRecordControl {
    static appService: AppService;
    static globalTablesService: GlobalTablesService;
    static basicContentService: BasicContentService;

    public static async saveChanges(fieldsToUpdate: Array<EnpsField>, record: StorytellingRecord) {
        if (!record.Guid || record.Guid.startsWith('@')) {
            // for (const field of fieldsToUpdate) {
            //     record.set(field.key, field.value);
            // }
            // EnpsRecordControl.appService.recordChanged(record);
        } else {
            //Update existing record
            const data: { [id: string]: any } = {};

            const titleField = fieldsToUpdate.find(field => field.key === EnpsRecordControl.appService.PSTFieldNames.Title);
            if (titleField && typeof titleField.value === 'string' && titleField.value.toString().trim() === '') {
                return;
            }

            for (const field of fieldsToUpdate) {
                const enpsField = EnpsRecordControl.basicContentService.nomWebServicesJson.convertor.serializeField(field.value, field.key);

                if (!(typeof field.value === 'string' || typeof field.value === 'number' || typeof field.value === 'boolean') && enpsField.usingRawValue) {
                    Util.saveWarningError(`EnpsControl.saveChanges() not implemented for type ${typeof field.value}`);
                    return;
                }

                if (enpsField.key === PSTFieldNames.TextCommands) {
                    const textCommandKeys = Object.keys(enpsField.value);
                    const textCommandValues = Object.values(enpsField.value);
                    if (textCommandKeys.length === textCommandValues.length && textCommandKeys.length > 0) {
                        data['TextCommandKeys'] = textCommandKeys;
                        data['TextCommandValues'] = textCommandValues;
                    }
                } else {
                    data[enpsField.key] = enpsField.value;
                }
            }

            // Make sure to pass record type
            data.Type = record.Type;

            const res = await EnpsRecordControl.basicContentService.updateBasicContentV2(record.Database, record.Path.fullPath, record.Guid, false, data, false, null);
            if (!res.status) {
                // TODO: error handling
            } else {
                // EnpsRecordControl.appService.recordChanged(record);
                // DataStore.set(res.data);
            }
        }
    }
}
